import { EVENT_CHILD_APP_CLOSED, DRAWER_BLEEDING } from './constants';
import 'requestidlecallback-polyfill';
import { urlState, uiState } from './state';

/**
 * A vanilla fetch implementation that raise errors on HTTP errors
 */
function fetchAPI(...args) {
  return fetch(...args).then(function (response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  });
}

export function notifyResizeEvent({
  target = window,
  onEnd = () => {},
  chartResizeOnly = false,
} = {}) {
  requestIdleCallback(() => {
    target.dispatchEvent(new CustomEvent('resize', { detail: chartResizeOnly }));
    onEnd();
  });
}

export function notifyChildAppClosed(target = window) {
  requestIdleCallback(() => {
    target.dispatchEvent(new CustomEvent(EVENT_CHILD_APP_CLOSED));
  });
}

export function cleanUrlParams() {
  const defaultUrlParams = new URLSearchParams();
  urlState.disabled && defaultUrlParams.append('disabled', true);
  urlState.theme && defaultUrlParams.append('theme', urlState.theme);
  const newUrl = defaultUrlParams.toString()
    ? `?${defaultUrlParams.toString()}`
    : window.location.pathname;
  history.pushState(null, null, newUrl);
}

export function expandInput() {
  if (uiState.inputRef && uiState.inputRef.current) {
    uiState.inputRef.current.style.height = '100%';
    uiState.inputExpandRef.current.style.bottom = `${-DRAWER_BLEEDING + 10}px`;
    uiState.isInputExpanded = !uiState.isInputExpanded;
  }
}

export function urlDownload({
  altitude,
  apiBase,
  floodRecurrence,
  horizon,
  hydroModel,
  indicator,
  level,
  mapType,
  month,
  rcp,
  region,
  regionalAggregation,
  regionName,
  setFileDownloadUrl,
  temporalAggregation,
  threshold,
  visualisedLayer,
}) {
  const qsData = {
    horizon,
    mapType,
    month,
    rcp,
    region,
    regionalAggregation,
    regionName,
    temporalAggregation,
    ...(threshold ? { threshold: threshold } : null),
    ...(altitude ? { altitude: altitude } : null),
    ...(level ? { level: level } : null),
    ...(floodRecurrence ? { floodRecurrence: floodRecurrence } : null),
    ...(hydroModel ? { hydroModel: hydroModel } : null),
  };
  delete qsData.month;
  const searchParams = new URLSearchParams(qsData);
  setFileDownloadUrl(
    `${apiBase}/geojson/${indicator}/${visualisedLayer}/download?${searchParams.toString()}`,
  );
}

export { fetchAPI };
